module.exports = __webpack_public_path__ + "img/chat.c5609f7e.png";